import './mobile-menu.scss';
import { ReactComponent as MobileCloseIcon } from '@/assets/icons/svg/common/mobile-close-icon.svg';
import { ReactComponent as MainLogo } from '@/assets/icons/svg/common/main-logo.svg';
import { ReactComponent as ArrowDownIcon } from '@/assets/icons/svg/common/arrow-down-icon.svg';
import { ReactComponent as InquiryArrow } from '@/assets/icons/svg/common/inquiry-arrow.svg';

import classNames from 'classnames';
import { menuListType } from './header';
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useRouter } from '@/hooks/useRouter';
import paths from '@/routes/paths';

type Props = {
	mobileMenuOpen: boolean;
	setMobileMenuOpen: (mobileMenuOpen: boolean) => void;
	menuList: menuListType[];
};

const MobileMenu = ({ mobileMenuOpen, setMobileMenuOpen, menuList }: Props) => {
	const [openMenu, setOpenMenu] = useState<number | null>(null);
	const router = useRouter();
	const location = useLocation();

	// 배경 스크롤 방지
	useEffect(() => {
		if (mobileMenuOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = '';
		}
		// cleanup: unmount 시에도 원복
		return () => {
			document.body.style.overflow = '';
		};
	}, [mobileMenuOpen]);

	// 메뉴 아이템 클릭 시 호출되는 함수
	const toggleMenu = (id: number) => {
		setOpenMenu((prev) => (prev === id ? null : id));
	};

	const handleClickInquiry = () => {
		router.push(paths.inquiry);
		setMobileMenuOpen(false);
	};

	return (
		<div
			className={`mobile-header-menu-box ${mobileMenuOpen ? 'open' : ''}`}
		>
			<div className="mobile-header-top">
				<Link to="/" onClick={() => setMobileMenuOpen(false)}>
					<MainLogo className="main-logo" />
				</Link>
				<MobileCloseIcon
					className="mobile-close-icon"
					onClick={() => setMobileMenuOpen(false)}
				/>
			</div>

			<nav className="mobile-menu">
				<ul className="mobile-menu-list">
					{menuList.map((menu) => {
						// 모바일에서도 현재 메뉴나 서브메뉴 경로 매칭시 active 적용
						const isMenuActive =
							location.pathname.includes(menu.path) ||
							(menu.subMenu &&
								menu.subMenu.some((sub) =>
									location.pathname.includes(sub.path)
								)) ||
							(menu.mobileSubMenu &&
								menu.mobileSubMenu.some(
									(mSub) =>
										mSub.depsMenu &&
										mSub.depsMenu.some((deps) =>
											location.pathname.includes(
												deps.path
											)
										)
								));

						return (
							<li
								key={menu.id}
								className={classNames('mobile-menu-item', {
									open: openMenu === menu.id
								})}
							>
								{menu.subMenu || menu.mobileSubMenu ? (
									// 서브메뉴가 있는 경우
									<div
										onClick={() => toggleMenu(menu.id)}
										className={classNames('menu-label', {
											open: openMenu === menu.id,
											active: isMenuActive
										})}
									>
										<p className="menu-label-text">
											{menu.label}
										</p>
										<ArrowDownIcon />
									</div>
								) : (
									// 서브메뉴가 없는 경우
									<Link
										to={menu.path}
										className={classNames('menu-label', {
											active: isMenuActive
										})}
										onClick={() => setMobileMenuOpen(false)}
									>
										<p className="menu-label-text">
											{menu.label}
										</p>
									</Link>
								)}
								{/* 서브 메뉴가 있는 경우 */}
								{menu.subMenu && (
									<ul
										className={classNames(
											'mobile-sub-menu-list',
											{ open: openMenu === menu.id }
										)}
									>
										{menu.subMenu.map((subMenu) => {
											const isSubActive =
												location.pathname ===
												subMenu.path;
											return (
												<li
													key={subMenu.id}
													className={classNames(
														'mobile-sub-menu-item',
														{ active: isSubActive }
													)}
												>
													<Link
														to={subMenu.path}
														className="mobile-sub-menu-text"
														onClick={() =>
															setMobileMenuOpen(
																false
															)
														}
													>
														{subMenu.label}
													</Link>
												</li>
											);
										})}
									</ul>
								)}
							</li>
						);
					})}
				</ul>
			</nav>
			<div className="mobile-menu-inquiry" onClick={handleClickInquiry}>
				<p>문의하기</p>
				<InquiryArrow className="inquiry-arrow" />
			</div>
		</div>
	);
};

export default MobileMenu;
